import { ApolloClient } from '@apollo/client';

import { GetDisplayCategoriesDocument, OffersDocument } from '@ocx/graphql';
import { logInDev } from '@ocx/utils';

import { getCachedDisplayCategories, getCachedOffersQueries } from './offers.cache';

export const restoreOffersCache = async (client: ApolloClient<unknown>): Promise<void> => {
  const [offersEntries, categories] = await Promise.all([getCachedOffersQueries(), getCachedDisplayCategories()]);

  for (const entry of offersEntries) {
    try {
      client.writeQuery({ query: OffersDocument, variables: entry.variables, data: entry.data });
    } catch (e) {
      logInDev(e);
    }
  }

  if (categories) {
    try {
      client.writeQuery({
        query: GetDisplayCategoriesDocument,
        variables: categories.variables,
        data: categories.data,
      });
    } catch (e) {
      logInDev(e);
    }
  }
};
